import React from 'react';
import { useTranslator } from 'tradera/lang/translate';
import { Button } from 'tradera/components/atoms/button/button';
import { ScrollableModal } from 'tradera/components/scrollable-modal/scrollable-modal';
import { useAppDispatch, useAppSelector } from 'tradera/state/hooks';
import { Text } from 'tradera/components/atoms/text/text';
import { closeModal } from 'tradera/state/ui/reducer';

export const CANCEL_ITEM_MODAL_ID = 'CANCEL_ITEM';

export const CancelItemModal = () => {
    const dispatch = useAppDispatch();
    const { t } = useTranslator();

    const { currentModal, currentModalData } = useAppSelector(
        (state) => state.ui.modals
    );

    const isModalOpen = currentModal === CANCEL_ITEM_MODAL_ID;
    const itemId = currentModalData?.itemId;

    const showModal = isModalOpen && !!itemId;

    return (
        <ScrollableModal
            show={showModal}
            onClose={() => dispatch(closeModal())}
            onDismiss={() => dispatch(closeModal())}
            maxWidth="40vh"
            title={t('cancel_item_modal_title')}
            footer={
                <Button theme="primary" href={`/selling/edit/${itemId}`}>
                    {t('cancel_item_modal_button')}
                </Button>
            }
            mobileBottomSheet>
            <div className="d-flex flex-column justify-content-between">
                <Text as="p" className="mb-5">
                    {t('cancel_item_modal_text_1')}
                </Text>
                <Text as="p" font="hansen" className="mb-1">
                    {t('cancel_item_modal_text_2')}
                </Text>
                <Text>{t('cancel_item_modal_text_3')}</Text>
            </div>
        </ScrollableModal>
    );
};
